function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { centerCrop, makeAspectCrop } from 'react-image-crop';
export var COMPANY_LOGO_WIDTH = 240;
export var COMPANY_LOGO_HEIGHT = 80;
var centerAspectCrop = function(mediaWidth, mediaHeight, aspect) {
    return centerCrop(makeAspectCrop({
        unit: 'px',
        width: COMPANY_LOGO_WIDTH,
        height: COMPANY_LOGO_HEIGHT
    }, aspect, mediaWidth, mediaHeight), mediaWidth, mediaHeight);
};
// Creates a cropped image from the source image and crop area
var createCroppedImage = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(image, pixelCrop) {
        var scale, canvas, ctx, cropCenterX, cropCenterY, scaleX, scaleY, scaleOffsetX, scaleOffsetY, sourceCenterX, sourceCenterY, sourceWidth, sourceHeight, sourceX, sourceY;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            scale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 1;
            if (!pixelCrop || !image) {
                throw new Error('Crop or image is null');
            }
            // Create a canvas with fixed output dimensions
            canvas = document.createElement('canvas');
            canvas.width = COMPANY_LOGO_WIDTH;
            canvas.height = COMPANY_LOGO_HEIGHT;
            ctx = canvas.getContext('2d');
            if (!ctx) {
                throw new Error('No 2d context');
            }
            // Clear with white background
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            // Calculate center of the crop in the displayed image
            cropCenterX = pixelCrop.x + pixelCrop.width / 2;
            cropCenterY = pixelCrop.y + pixelCrop.height / 2;
            // Calculate the source coordinates in the natural image
            scaleX = image.naturalWidth / image.width;
            scaleY = image.naturalHeight / image.height;
            // Calculate the offset from the center when zoomed
            scaleOffsetX = (cropCenterX - image.width / 2) / scale;
            scaleOffsetY = (cropCenterY - image.height / 2) / scale;
            // Calculate center point in the original-sized image
            sourceCenterX = (image.width / 2 + scaleOffsetX) * scaleX;
            sourceCenterY = (image.height / 2 + scaleOffsetY) * scaleY;
            // Calculate source width and height (adjusted for zoom/scale)
            sourceWidth = pixelCrop.width / scale * scaleX;
            sourceHeight = pixelCrop.height / scale * scaleY;
            // Calculate source top-left position from the center coordinates
            sourceX = sourceCenterX - sourceWidth / 2;
            sourceY = sourceCenterY - sourceHeight / 2;
            // Draw the cropped image onto the canvas
            try {
                ctx.drawImage(image, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, canvas.width, canvas.height);
            } catch (err) {
                console.error('Canvas drawing error:', err, {
                    sourceParams: {
                        x: sourceX,
                        y: sourceY,
                        width: sourceWidth,
                        height: sourceHeight
                    },
                    imageSize: {
                        naturalWidth: image.naturalWidth,
                        naturalHeight: image.naturalHeight
                    }
                });
                throw err;
            }
            // Convert canvas to blob and then to base64
            return [
                2,
                new Promise(function(resolve, reject) {
                    canvas.toBlob(function(blob) {
                        if (!blob) {
                            reject(new Error('Canvas toBlob result is null'));
                            return;
                        }
                        // to base64
                        var reader = new FileReader();
                        reader.addEventListener('load', function() {
                            if (typeof reader.result === 'string') {
                                resolve({
                                    blob: blob,
                                    base64: reader.result
                                });
                            } else {
                                reject(new Error('FileReader result is not a string'));
                            }
                        });
                        reader.addEventListener('error', function() {
                            var _reader_error;
                            reject(new Error('FileReader error: ' + ((_reader_error = reader.error) === null || _reader_error === void 0 ? void 0 : _reader_error.message)));
                        });
                        reader.readAsDataURL(blob);
                    }, 'image/jpeg', 1);
                })
            ];
        });
    });
    return function createCroppedImage(image, pixelCrop) {
        return _ref.apply(this, arguments);
    };
}();
export { centerAspectCrop, createCroppedImage };
